<template>
  <div id="contenedor-editar-subtipo-obra">
    <v-form ref="editarSubTipoObra" v-model="esFormularioValido">
      <v-card>
        <v-card-title class="secondary--text">
          Editar subtipo de obra
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <custom-select
            v-model="subTipoObra.idTipo"
            label="Tipo de Obra"
            :items="tiposObras"
            item-value="id"
            item-text="descripcion"
            :rules="[mixReglas.requerido]"
            v-on:keypress.enter="mixActualizarSubTipoObra"
            required
          >
          </custom-select>
          <custom-text-field
            v-model="subTipoObra.descripcion"
            label="Descripción"
            :rules="[mixReglas.requerido]"
            v-on:keypress.enter="mixActualizarSubTipoObra"
            required
          >
          </custom-text-field>
          <v-label>Color</v-label>
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-avatar
                class="ma-2"
                size="40"
                :color="subTipoObra.color"
                readonly
                v-bind="attrs"
                v-on="on"
              >
              </v-avatar>
            </template>
            <v-color-picker
              v-model="subTipoObra.color"
              mode="hexa"
              hide-canvas
              hide-inputs
              hide-mode-switch
              hide-sliders
              show-swatches
              swatches-max-height="200"
            >
            </v-color-picker>
          </v-menu>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixActualizarSubTipoObra"
            :disabled="!esFormularioValido"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Actualizar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import mixCatalogoSubTiposObra from './mixCatalogoSubTiposObra';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomSelect from '@/components/inputs/Select.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'CatalogosSubtiposdeobraEditar',
  mixins: [mixCatalogoSubTiposObra],
  props: {
    subTipoObraEditar: Object,
  },
  components: {
    CustomTextField,
    CustomSelect,
    CustomButton,
  },
  data() {
    return {
      esFormularioValido: false,
      enviandoFormulario: false,
      subTipoObra: {
        idTipo: this.subTipoObraEditar.idTipo, // id del padre
        descripcion: this.subTipoObraEditar.descripcion,
        color: this.subTipoObraEditar.color,
      },
      menu: false,
    };
  },
  methods: {
    cerrar() {
      this.limpiarFormulario();
      this.subTipoObra.color = '';
      this.$emit('cerrar');
    },
    limpiarFormulario() {
      this.$refs.editarSubTipoObra.reset();
    },
  },
};
</script>

<style>
</style>
